import { CCard, CCardBody } from '@coreui/react-pro'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import TableFooter from 'src/components/TableFooter'
import { LogContext } from 'src/context/LogContext'
import useColumns from 'src/hooks/useColumns'
import useFetch from 'src/hooks/useFetch'
import UseToastAlert from 'src/hooks/useToastAlert'
import { getLanguageId } from 'src/selectors/LanguageSelector'
import OrderLogsDataService from 'src/services/OrderLogsDataService'
import { getDefaultOrderLogColumns } from 'src/transformers/LogsTransformer'
import { removeEmptyObjectValues } from 'src/utils/helpers'
import { INITIAL_SEARCH } from './partials/Constants'
import OrderLogsHeader from './partials/OrderLogsHeader'
import OrderLogsSearchForm from './partials/OrderLogsSearchForm'
import OrderLogsTable from './partials/OrderLogsTable'

const OrderLogs = () => {
  const { t } = useTranslation('logs')
  const languageId = useSelector(getLanguageId)
  const [refresh, setRefresh] = useState(false)
  const [ToastAlert, showToast] = UseToastAlert()
  const [searchParams, setSearchParams] = useState(INITIAL_SEARCH)
  const [selectedOrderOption, setSelectedOrderOption] = useState({})
  const [columns, onColumnManagerChange] = useColumns(getDefaultOrderLogColumns(t))
  const [orderLogs, fetchOrderLogs, isLoading] = useFetch(showToast, t)

  const handleSearchChange = (event) => {
    if (event?.for === 'order_id') {
      setSearchParams({ ...searchParams, internal_order: event.label })
      setSelectedOrderOption(event)
    } else {
      const { name, value } = event.target
      if (value.trim() === '' && value !== '') return
      setSearchParams({ ...searchParams, [name]: value })
    }
  }

  const handleSearchReset = () => {
    setSearchParams(INITIAL_SEARCH)
    setRefresh(!refresh)
  }

  useEffect(() => {
    fetchOrderLogs(searchParams, OrderLogsDataService.getAll)
    //eslint-disable-next-line
  }, [refresh])

  const handleSearchSubmit = (event) => {
    event.preventDefault()
    setSearchParams({ ...removeEmptyObjectValues(searchParams), page: 1 })
    setRefresh(!refresh)
  }

  const onActivePageChange = (p) => {
    setSearchParams({ ...searchParams, page: p })
    setRefresh(!refresh)
  }

  const handleClearOrder = () => {
    setSearchParams({ ...searchParams, internal_order: '' })
  }

  const params = {
    onColumnManagerChange,
    handleSearchReset,
    handleSearchChange,
    searchParams,
    languageId,
    handleSearchSubmit,
    orderLogs,
    columns,
    isLoading,
    selectedOrderOption,
    handleClearOrder,
    t,
  }

  return (
    <LogContext.Provider value={params}>
      <ToastAlert />
      <CCard>
        <OrderLogsHeader />
        <CCardBody className="p-0">
          <OrderLogsSearchForm />
          <OrderLogsTable />
        </CCardBody>
        <TableFooter data={orderLogs} onActivePageChange={onActivePageChange} />
      </CCard>
    </LogContext.Provider>
  )
}

export default OrderLogs
